/**
 * User display-locale helper (#18930 / BUG-022).
 *
 * The agent web app has no UI translation framework yet, so the Account
 * Language preference could be saved but changed nothing — the interface stayed
 * English and <html lang> stayed "en". Until full i18n ships, this at least
 * applies the saved locale to the document language (so <html lang> reflects the
 * choice and screen readers announce the right language) and caches it so the
 * attribute is correct on reload, before the profile request completes.
 *
 * Source of truth is the server preference (preferences.locale); the cache is
 * only a convenience so the <html lang> is right immediately on load.
 */
const STORAGE_KEY = 'ui-locale';

/** Set <html lang> from the saved locale and cache it for next load. No-op on
 * an empty value; never throws (private mode / blocked storage). */
export function applyUserLocale(locale: string | undefined | null): void {
  const loc = (locale || '').trim();
  if (!loc) return;
  try {
    document.documentElement.lang = loc;
  } catch {
    /* ignore — document not available */
  }
  try {
    localStorage.setItem(STORAGE_KEY, loc);
  } catch {
    /* ignore — storage blocked */
  }
}

/** The cached locale, for an immediate <html lang> on app load. */
export function getStoredUserLocale(): string | null {
  try {
    return localStorage.getItem(STORAGE_KEY);
  } catch {
    return null;
  }
}
